import * as moment from 'moment-timezone';
import isNull from 'lodash/isNull';
import { DATE_FORMAT, TIME_ZONE } from '../const/date.const';
import { FALLBACK_MESSAGE } from '../const/message.const';
import { getUtcString } from '../globals/globals';
/**
 * Reformats a date-time to a desired format
 * @param value : Date
 * @param dateFormat : Desired format of the date
 * @param timezone : User time zone
 * @returns string
 */
export function reformatDateTime(value, targetFormat = DATE_FORMAT.default, timezone = TIME_ZONE.default) {
    const dateTime = isNull(timezone)
        ? moment.utc(value)
        : moment.utc(value).tz(timezone);
    return dateTime.isValid()
        ? dateTime.format(targetFormat)
        : FALLBACK_MESSAGE.dash;
}
/**
 * Formats a date to a default format: DD/MM/YY HH:mm without TZ correction
 * @returns string
 */
export function formatDate(value, dateFormat = DATE_FORMAT.default) {
    const utcString = getUtcString(value);
    return moment.utc(utcString).format(dateFormat);
}
/**
 * Formats a date to a default format: DD/MM/YY HH:mm with User time zone correction
 * @param value : Timestamp
 * @param dateFormat : Desired format of the date
 * @param timezone : User time zone
 * @returns string
 */
export function formatUtc(value, dateFormat = DATE_FORMAT.default, timezone = TIME_ZONE.default) {
    const utcString = getUtcString(value);
    return moment
        .utc(utcString)
        .tz(timezone)
        .format(dateFormat);
}
/**
 * Formats an UTC corrected `DateRange`
 * @param dateRange : DateRange
 * @returns DateRange
 */
export function toUtcDateRange(dateRange) {
    const fromOffsetLocal = moment.parseZone(dateRange.from)
        .local()
        .utcOffset();
    const toOffsetLocal = moment.parseZone(dateRange.to)
        .local()
        .utcOffset();
    return {
        from: moment.utc(moment.parseZone(dateRange.from)
            .utcOffset(fromOffsetLocal, true)
            .startOf('day')
            .toString()).format(),
        to: moment.utc(moment.parseZone(dateRange.to)
            .utcOffset(toOffsetLocal, true)
            .endOf('day')
            .toString()).format(),
    };
}
